import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateDefinition } from '../api/agent-definitions.api';
import { AGENT_BUILDER_QUERY_KEYS } from '../api/query-keys';

/**
 * Takes a built agent out of use: archived, it is no longer offered or run, and the builder can
 * restore it. What deleting a custom agent from the Tools list does.
 */
export function useArchiveDefinition() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id: string) => updateDefinition(id, { status: 'archived' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: AGENT_BUILDER_QUERY_KEYS.all }),
  });
  return { archive: mutation.mutateAsync, isArchiving: mutation.isPending };
}
